








































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { UserProfile } from '../../../BotUsers/components/Users/types'
import { ProfileTabsHelper, UserProfileConfig } from '../../types'
import ProfileNotices from './Tabs/ProfileNotices.vue'
import ProfileProperties from './Tabs/ProfileProperties.vue'
import ProfileSubscriptions from './Tabs/ProfileSubscriptions.vue'

enum ActiveTab {
  Properties,
  Notices,
  Subscription,
}

@Component({
  data() {
    return {
      ActiveTab,
    }
  },
  components: {
    ProfileProperties,
    ProfileNotices,
    ProfileSubscriptions,
  }
})
export default class ProfileTabs extends Vue {
  @Prop() profile!: UserProfile

  @Prop() config!: ProfileTabsHelper

  @Prop() mediaTargetId!: UserProfileConfig['mediaTargetId']

  activeTab: ActiveTab = ActiveTab.Properties
}
